export const NAV = {
  logo: "nav-logo",
  linkManuale: "nav-link-manuale",
  linkBenefici: "nav-link-benefici",
  linkAnteprima: "nav-link-anteprima",
  linkRecensioni: "nav-link-recensioni",
  linkFaq: "nav-link-faq",
  ctaBuy: "nav-cta-buy",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  section: "hero-section",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const CHECKOUT = {
  section: "checkout-section",
  form: "checkout-form",
  name: "checkout-name-input",
  email: "checkout-email-input",
  submit: "checkout-submit-btn",
  success: "checkout-success",
  downloadBtn: "checkout-download-btn",
  downloadItem: (pid) => `checkout-download-${pid}`,
  upsellToggle: "checkout-upsell-toggle",
  buyAgain: "checkout-buy-again",
};

export const NEWSLETTER = {
  form: "newsletter-form",
  email: "newsletter-email-input",
  submit: "newsletter-submit-btn",
};

export const FAQ = {
  section: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const MOBILE_CTA = {
  bar: "mobile-cta-bar",
  button: "mobile-cta-button",
};

export const COOKIE = {
  banner: "cookie-banner",
  accept: "cookie-accept",
  reject: "cookie-reject",
};

export const DISCOUNT = {
  modal: "discount-modal",
  email: "discount-email-input",
  submit: "discount-submit-btn",
  close: "discount-close-btn",
  code: "discount-code",
  copy: "discount-copy-btn",
};

export const PREVIEW = {
  section: "preview-section",
  item: (i) => `preview-item-${i}`,
  prev: "preview-prev",
  next: "preview-next",
  lightbox: "preview-lightbox",
};
